<template>
  <dsf-home-tab-panel
    ref="panel"
    class="ds-schedule-box schedule-list"
    v-bind="panelConfig"
    :slots="realConfig"
    add-show
    more-show
    :add-icon="addIcon"
    :add-text="addText"
    @setting-click="settingClick">
    <template v-for="config in realConfig" :slot="config.name">
      <dsf-tjy-unite-schedule-list
        ref="scheduleList"
        :key="config.name"
        :url="config.url"
        :holiday-url="holidayUrl"
        :is-show-holiday="isShowHoliday"
        :is-design="isDesign"
        :is-switch="isSwitch"
        :setting-config="settingConfig || {
          pageSize: 2,
          type: defaultShowType,
          ellipsis: true,
        }"
        :default-active-mode="defaultActiveMode"
        :weekend-height-light="weekendHeightLight"
        :festival-height-light="festivalHeightLight"
        :is-show-agenda-type="isShowAgendaType"
        :is-show-address="isShowAddress"
        is-parameter>
      </dsf-tjy-unite-schedule-list>
    </template>
  </dsf-home-tab-panel>
</template>

<script>
export default dsf.component({
  name: "DsfTJYSchedule",
  ctrlCaption: "日程安排",
  mixins: [$mixins.control],
  design: {
    isMask: false
  },
  props: {
    // 宽度
    width: {
      type: String,
      default: "100%"
    },
    // 高度
    height: {
      type: String,
      default: "100%"
    },
    // 显示阴影
    showShadow: {
      type: Boolean,
      default: true
    },
    // 边框
    padding: {
      type: Array,
      default() {
        return [10, 20, 0, 20];
      }
    },
    // 边框
    margin: {
      type: Array,
      default() {
        return [8, 8, 8, 8];
      }
    },
    // 风格
    styleType: {
      type: String,
      default: "compact"
    },
    // 是否允许切换周
    isSwitch: {
      type: Boolean,
      default: false
    },
    active: {
      type: String,
      default: ""
    },
    schedulePanelConfig: {
      type: Array,
      default() {
        return [
          {
            title: "我的日程",
            name: "mySchedule",
            hide: false,
            badge: null,
            lazy: false,
            more: {},
            url: "/agenda/info/queryUserAgendaByDate"
          },
          {
            title: "领导日程",
            name: "leaderSchedule",
            hide: false,
            badge: null,
            lazy: false,
            more: {},
            url: "/agenda/info/queryUserAgendaByDate"
          }
        ];
      }
    },
    // 圆角
    borderRadius: {
      type: Array,
      default() {
        return [0, 0, 0, 0];
      }
    },
    // 个性化配置
    settingConfig: {
      type: Object,
      default: null
    },

    //  显示设置
    settingShow: {
      type: Boolean,
      default: true
    },
    //  设置文字
    settingText: {
      type: String,
      default: ""
    },
    //  设置Icon
    settingIcon: {
      type: String,
      default: "shezhi"
    },
    /**
     * 默认时间显示哪一天
     *   0: 有事件的那天
     *   1: 默认今天
     *   2: 默认周一
     */
    defaultActiveMode: {
      type: String,
      default: "0"
    },
    // 显示模式选项
    settingTypeOptions: {
      type: Array,
      default() {
        return ["week", "week2", "month"];
      }
    },
    // 默认显示模式
    defaultShowType: {
      type: String,
      default: "week"
    },
    // 显示“新增”按钮
    addShow: {
      type: Boolean,
      default: true
    },
    // 新增按钮图标 icon名称
    addIcon: {
      type: String,
      default: "hao"
    },
    // 新增按钮文字
    addText: {
      type: String,
      default: "新增日程"
    },
    // 显示“更多”按钮
    moreShow: {
      type: Boolean,
      default: true
    },
    // 更多按钮图标 icon名称
    moreIcon: {
      type: String,
      default: "gengduo"
    },
    // 更多按钮文字
    moreText: {
      type: String,
      default: "更多"
    },
    // 周末高亮
    weekendHeightLight: {
      type: Boolean,
      default: true
    },
    // 节日高亮
    festivalHeightLight: {
      type: Boolean,
      default: false
    },
    // 假日接口
    holidayUrl: {
      type: String,
      default: "/agenda/info/findHoliday"
    },
    // 是否显示假日
    isShowHoliday: {
      type: Boolean,
      default: false
    },
    // 是否显示日程类型
    isShowAgendaType: {
      type: Boolean,
      default: false,
    },
    // 是否显示日程地址
    isShowAddress: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      classInfo: {},
      // 当前选中班级的索引
      activeClassIndex: 0
    };
  },
  computed: {
    // mainStyle() {
    //   let { padding } = this;
    //   let style = {};
    //   style.padding = padding.join("px ") + "px";
    //   return style;
    // },
    realConfig() {
      return _.filter(this.schedulePanelConfig, (config) => !config.hide);
    },
    panelConfig() {
      return {
        title: "",
        titleIcon: "",
        width: this.width,
        height: this.height,
        padding: this.padding,
        margin: this.margin,
        isDesign: this.isDesign,
        styleType: this.styleType,
        borderRadius: this.borderRadius,
        active: this.active,
        forceShowTab: false,
        // singleSlot: true,
        settingShow: this.settingShow,
        settingText: this.settingText,
        settingIcon: this.settingIcon,
        moreShow: this.moreShow,
        moreIcon: this.moreIcon,
        moreText: this.moreText,
        addShow: this.addShow,
        addText: this.addText,
        addIcon: this.addIcon
      };
    }
  },
  created() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", "100%");
    }
  },
  methods: {
    settingClick() {
      this.$openDialog({
        title: "个性化设置",
        content: "DsfScheduleListSetting",
        height: "500px",
        width: "800px",
        params: {
          settingTypeOptions: this.settingTypeOptions,
          settingConfig: this.settingConfig || {
            pageSize: 2,
            type: this.defaultShowType,
            ellipsis: true
          }
        },
        btns: [
          {
            text: "重置",
            handler: () => {
              let settingConfig = {
                pageSize: 2,
                type: this.defaultShowType,
                ellipsis: true
              };
              this.$emit("update:settingConfig", settingConfig);
              this.$addCustom(this.caption, { settingConfig });
            }
          },
          {
            text: "确定",
            type: "",
            handler: (res) => {
              let settingConfig = res.yes();
              this.$emit("update:settingConfig", settingConfig);
              this.$addCustom(this.caption, { settingConfig });
            }
          },
          {
            text: "取消"
          }
        ]
      });
    }
  }
});
</script>